import { Attachment, AttType } from 'src/graphql/generated';
import { ALSFormData } from 'src/components/Pages/ALS/types';
import { prepareAttachments } from 'src/components/Attachments/utils';
import { useUploadAttachments } from 'src/hooks/useUploadAttachments';

export const useAlsAttachmentsUpload = () => {
  const uploadCPRFiles = useUploadAttachments(AttType.Alscprevidenceattachments);
  const uploadSRFiles = useUploadAttachments(AttType.Alsspecificattachments);
  const uploadPCFiles = useUploadAttachments(AttType.Alspcattachments);
  const processAttachments = async (
    data: ALSFormData
  ): Promise<{
    aggregatedCPRAttachments: Attachment[];
    aggregatedSRAttachments: Attachment[];
    aggregatedPCAttachments: Attachment[];
  }> => {
    // Separate new Files vs existing attachments
    const localCprFiles = data.alsCprEvidenceAttachments.filter(
      (a): a is File => a instanceof File
    );

    const previousCPRAttachments = data.alsCprEvidenceAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    const localSrFiles = data.alsSpecificAttachments.filter((a): a is File => a instanceof File);

    const previousSRAttachments = data.alsSpecificAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    const localPCFiles = data.alsPCAttachments.filter((a): a is File => a instanceof File);

    const previousPCAttachments = data.alsPCAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    try {
      // Upload in parallel
      const [newCPRAttachments, newSRAttachments, newPCAttachments] = await Promise.all([
        localCprFiles.length ? uploadCPRFiles(localCprFiles) : Promise.resolve([]),
        localSrFiles.length ? uploadSRFiles(localSrFiles) : Promise.resolve([]),
        localPCFiles.length ? uploadPCFiles(localPCFiles) : Promise.resolve([])
      ]);

      return {
        aggregatedCPRAttachments: [
          ...prepareAttachments(previousCPRAttachments),
          ...prepareAttachments(newCPRAttachments as Attachment[])
        ],
        aggregatedSRAttachments: [
          ...prepareAttachments(previousSRAttachments),
          ...prepareAttachments(newSRAttachments as Attachment[])
        ],
        aggregatedPCAttachments: [
          ...prepareAttachments(previousPCAttachments),
          ...prepareAttachments(newPCAttachments as Attachment[])
        ]
      };
    } catch (error) {
      throw error; // let component handle error
    }
  };

  return { processAttachments };
};
